<template>
    <section>
        <gallery v-if="showGallery" :images="product.images" @closeGallery="closeGallery"></gallery>

        <section class="pagination_area">
             <div class="container">
                 <div class="row">
                     <div class="col-md-12">
                         <div class="pagination_box">
                             <ul>
                                 <li v-for="(c,i) in categories">
                                     <router-link tag="a" :to="'/list?filter='+createNavigationUrl(c.id)">{{c.name}}
                                         <i class="fa fa-angle-right" aria-hidden="true"></i>
                                     </router-link>
                                 </li>
                                 <li >
                                    <a onclick="history.back()">
                                        Vissza az előző oldalra
                                    </a>
                                </li>
                             </ul>
                         </div>
                     </div>
                 </div>
             </div>
        </section>

        <section class="soproni_big_area">
            <div class="container">
                <div class="row">
                    <div class="col-sm-3">
                        <filter-view v-if="product.parentCategory" :propertyGroups="[]" :sc="product.parentCategory" @filterChanged="categorySelected"></filter-view>
                    </div>

                    <div class="col-sm-9">
                        <div class="row soproni_big_area_white" style="height:auto;">
                            <div class="col-sm-6">
                                <div class="soproni_big_can">
                                    <div class="soproni_big_can_img text-center">
                                        <img :src="product.imageUrl" alt="" style="width: 100%; cursor:pointer;" @click="openGallery">
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="soproni_big_conts">
                                    <div class="soproni_big_conts_box">
                                        <div class="soproni_klasszikus">
                                            <div class="soproni_klasszikus_title">
                                                <h2>{{product.name}}</h2>
                                            </div>
                                            <div class="soproni_klasszikus_price_box">
                                                <div class="soproni_klasszikus_price">
                                                    <h4>Bruttó {{product.price && product.price.toLocaleString('hu')}} Ft <span>{{product.originalPrice == 0?'':(product.originalPrice &&product.originalPrice.toLocaleString('hu'))+' Ft'}}</span></h4>
                                                    <h4 style="font-size:20px;">Nettó {{(product.price / 1.27).toFixed(0).toLocaleString('hu')}} Ft <span>{{product.originalPrice == 0?'':(product.originalPrice / 1.27).toFixed(0).toLocaleString('hu')+' Ft'}}</span></h4>
                                                </div>
                                            </div>
                                            <div class="soproni_klasszikus_ingri" v-if="product.additionalFields">
                                                <section v-for="pg in product.propertyGroups">
                                                    <p v-if="pg.propertyGroup.type == 'VALUE'">
                                                        {{pg.propertyGroup.name}}: {{pg.value}}
                                                    </p>
                                                    <p v-for="p in pg.properties">
                                                        {{pg.propertyGroup.name}}: {{p.name}}
                                                    </p>
                                                </section>
                                                <p>
                                                    {{product.additionalFields.type == 'KG'?'Tömeg':'Térfogat'}}: {{product.additionalFields.type == 'KG'?product.additionalFields.netWeight/1000:product.additionalFields.volume}} {{product.additionalFields.type == 'KG'?'kg':'L'}}
                                                </p>
                                                <p v-if="product.additionalFields.alcohol && product.additionalFields.alcohol != 0">
                                                    Alkoholtartalom: {{product.additionalFields.alcohol}}%
                                                </p>
                                                <p>
                                                    Bruttó egységár: {{(product.price / (product.additionalFields.type == 'KG'?product.additionalFields.netWeight/1000:product.additionalFields.volume)).toFixed(0).toLocaleString('hu')}} Ft/{{product.additionalFields.type == 'KG'?'kg':'L'}}
                                                </p>
                                                <br />
                                                <p>
                                                    {{product.description}}
                                                </p>
                                                <br />
                                                <h4>Rendelési adatok</h4>
                                                <p>
                                                    Bruttó tömeg: {{(product.additionalFields.netWeight+product.additionalFields.additionalWeight)/1000}} kg
                                                </p>
                                                <p v-if="product.additionalFields.additionalPrice > 0">
                                                    Üveg betétdíj: {{product.additionalFields.additionalPrice.toLocaleString('hu')}} Ft
                                                </p>
                                                <p v-if="product.additionalFields.minOrderQuantity > 0">
                                                    Minimális rendelési mennyiség: {{product.additionalFields.minOrderQuantity}} db
                                                </p>
                                                <p v-if="product.additionalFields.packageSize > 0">
                                                    Egy csomag: {{product.additionalFields.packageSize}} db termék
                                                </p>
                                                <p v-if="product.additionalFields.additionalPackageWeight > 0">
                                                    Rekesz súly: {{product.additionalFields.additionalPackageWeight /1000}} kg
                                                </p>
                                                <p v-if="product.additionalFields.additionalPackagePrice > 0">
                                                    Rekesz betétdíj: {{product.additionalFields.additionalPackagePrice.toLocaleString('hu')}} Ft
                                                </p>
                                                <br />
                                                <!-- <p>
                                                    Jelenleg készleten: {{product.availableQuantity}} db
                                                </p> -->
                                                <p v-if="product.availableQuantity">A termék jelenleg készleten van.</p>
                                            </div>

                                            <div class="big_quantity_boxs">
                                                <div class="row">
                                                    <template v-if="product.availableQuantity">
                                                        <div class="col-sm-4">
                                                            <div>
                                                                <form id="form" action="">
                                                                    <div class="form-group">
                                                                        <!-- <input v-model="quantity" id="quantity" class="form-control" type="number" name="date" :min="product.additionalFields.minOrderQuantity" :step="product.additionalFields.minOrderQuantity" :max="product.availableQuantity" >
                                                                        <button onclick="var e = $.Event('keypress'); e.which = 38; $('#quantity').trigger(e); console.log('valami');return false;">Növel</button> -->

                                                                        <div class="input-group spinner">
                                                                            <input v-model="quantity" type="number" class="form-control" disabled>
                                                                            <div class="input-group-btn-vertical">
                                                                              <button class="btn btn-default" type="button" @click="increment"><i class="fa fa-caret-up"></i></button>
                                                                              <button class="btn btn-default" type="button" @click="decrement"><i class="fa fa-caret-down"></i></button>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </form>
                                                            </div>
                                                        </div>
                                                        <!-- <div class="col-sm-1">
                                                            <div class="big_db">
                                                                <p>db</p>
                                                            </div>
                                                        </div> -->
                                                        <div class="col-sm-6">
                                                            <div class="big_quantity_btn">
                                                                <a @click="addToBasket">Kosárba<i class="fa fa-shopping-basket" aria-hidden="true"></i></a>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <div v-else>
                                                        <div class="">
                                                            <span style="font-size:14px; font-weight:bold;line-height:1;">
                                                                Vásárlási szándékát az alábbi gomb megnyomásával jelezheti felénk, miután beírta a vásárolni kívánt mennyiséget. A termék ára csak tájékoztató jellegű, válasz üzenetben értesítjük a termék aktuális áráról és szállítás várható időpontjáról.
                                                                <span v-if="!isLoggedIn"><br>Kérem adja meg az email címét is.</span>
                                                                <div class="row">
                                                                    <div class="col-sm-6 inputs">
                                                                        <input v-model="wishObj.quantity" type="number" placeholder="Mennyiség"/>
                                                                        <input v-model="wishObj.email" v-if="!isLoggedIn" type="text" placeholder="Email cím"/>
                                                                    </div>
                                                                    <div class="col-sm-6">
                                                                        <div class="big_quantity_btn" style="margin-top:20px;">
                                                                            <a @click="addToWishlist">Küldés<i class="fa fa-send" aria-hidden="true"></i></a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </span>
                                                        </div>
                                                        <!-- <div>
                                                            <span style="font-size:14px; font-weight:bold;line-height:1;">Vásárlási szándékát jelezze a <a href="mailto:webaruhaz@borakft.hu">webaruhaz@borakft.hu</a> címre küldött üzenetben. A termék ára csak tájékoztató jellegű, válasz üzenetben értesítjük a termék aktuális áráról és szállítás várható időpontjáról.</span>
                                                        </div> -->
                                                    </div>

                                                    <div class="col-sm-2">
                                                        <a @click="addRemoveWatched"><img :src="isWatched?'images/star_minus.png':'images/star_plus.png'" alt="" class="star" /></a>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <promoted v-if="product.parentCategory" :categoryId="product.parentCategory.id"></promoted>

                </div>
            </div>
        </section>

    </section>
</template>
<script>
import Promoted from '@pages/list/Promoted.vue'
import Filter from '@pages/list/Filter.vue'
import JS from './ProductDetailed.js'

export default{
    mixins:[JS],
    components:{
        Promoted,
        FilterView:Filter
    },
    methods:{
        categorySelected:function (search) {
            this.$router.push('/list?filter='+this.createNavigationUrl(search.categoryId));
        }
    }
}

</script>

<style>
.big_quantity_btn{
    cursor: pointer;
}
.star{
    margin-top: 20px;
    height: 50px;
    width: 50px;
    cursor: pointer;
}
/*Spinner*/
.spinner {
  width: 100px;
}
.spinner input {
  text-align: right;
}
.input-group-btn-vertical {
  position: relative;
  white-space: nowrap;
  width: 1%;
  vertical-align: middle;
  display: table-cell;
}
.input-group-btn-vertical > .btn {
  display: block;
  float: none;
  width: 100%;
  max-width: 100%;
  padding: 8px;
  margin-left: -1px;
  position: relative;
  border-radius: 0;
}
.input-group-btn-vertical > .btn:first-child {
  border-top-right-radius: 4px;
}
.input-group-btn-vertical > .btn:last-child {
  margin-top: -2px;
  border-bottom-right-radius: 4px;
}
.input-group-btn-vertical i{
  position: absolute;
  top: 0;
  left: 4px;
}
.inputs input{
    margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// ProductDetailed.vue?11bec7c9